import React from "react"
import InputRange, { Range } from "react-input-range"
import "react-input-range/lib/css/index.css"
import classes from "./Slider.module.css"

// const CustomSlider = withStyles({
//   root: {
//     color: lightBlack,
//     height: 6,
//   },
//   thumb: {
//     height: 20,
//     width: 20,
//     backgroundColor: "#fff",
//     border: "2px solid currentColor",
//     marginTop: -7,
//     marginLeft: -10,
//     "&:focus, &:hover, &$active": {
//       boxShadow: "inherit",
//     },
//   },
//   active: {},
//   valueLabel: {
//     left: "calc(-50% + 4px)",
//   },
//   track: {
//     height: 6,
//     borderRadius: 4,
//   },
//   rail: {
//     height: 6,
//     borderRadius: 4,
//   },
// })(Slider)

export interface CustomSliderProps {
  defaultValue?: number[]
  onChange?: (value: number[]) => void
  min?: number
  max: number
  step: number
}

const CustomSlider = ({
  defaultValue,
  min,
  max,
  step,
  onChange,
}: CustomSliderProps) => {
  const [value, setValue] = React.useState<Range | undefined>(
    defaultValue
      ? {
          min: defaultValue[0] as number,
          max: defaultValue[1] as number,
        }
      : undefined
  )

  const [uncontrolledValue, setUncontrolledValue] = React.useState<
    Range | undefined
  >()

  return (
    <div className={classes.root}>
      <InputRange
        allowSameValues={false}
        maxValue={Math.ceil(max)}
        minValue={Math.floor(min ?? 0)}
        step={step}
        formatLabel={(value) => `${value} €`}
        value={{
          min: value?.min ?? uncontrolledValue?.max ?? min ?? 0,
          max: value?.max ?? uncontrolledValue?.max ?? max ?? 1000,
        }}
        onChange={(value) => setValue(value as Range)}
        onChangeComplete={(value) => {
          onChange?.([(value as Range).min, (value as Range).max])
          setUncontrolledValue(value as Range)
        }}
      />
    </div>
  )
}

CustomSlider.defaultProps = {
  step: 1,
}

export default CustomSlider
